"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var styles_1 = require("./styles");
var IndeterminateIcon = function () { return (react_1.default.createElement("svg", { width: "12", height: "2", viewBox: "0 0 12 2", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("rect", { width: "12", height: "2", rx: "1", fill: "currentColor" }))); };
var indeterminateIcon = react_1.default.createElement(IndeterminateIcon, null);
var useStyles = (0, system_1.makeStyles)(function (theme) {
    return {
        checkbox: {
            width: 22,
            height: 22,
            padding: 0,
            borderRadius: 4,
        },
        errorState: {
            border: "2px solid ".concat(theme.go.schemes.colors.system.BgAttention, " !important"),
        },
    };
}, { name: 'GoCheckbox' });
exports.Checkbox = react_1.default.memo(react_1.default.forwardRef(function (_a, ref) {
    var className = _a.className, label = _a.label, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? 'end' : _b, error = _a.error, props = __rest(_a, ["className", "label", "labelPlacement", "error"]);
    var _c = (0, styles_1.useBaseStyles)({
        labelPlacement: label ? labelPlacement : undefined,
    }), go = _c.go, labelDisabled = _c.labelDisabled, labelRoot = _c.labelRoot, labelText = _c.labelText, classes = __rest(_c, ["go", "labelDisabled", "labelRoot", "labelText"]);
    var _d = useStyles(), checkbox = _d.checkbox, errorState = _d.errorState;
    var checkboxEl = (react_1.default.createElement(Checkbox_1.default, __assign({}, props, { inputRef: ref, className: (0, utils_1.cn)(className, go, checkbox, error ? errorState : undefined), classes: classes, checkedIcon: styles_1.checkedIcon, icon: styles_1.noIcon, indeterminateIcon: indeterminateIcon })));
    if (!label) {
        return checkboxEl;
    }
    return (react_1.default.createElement(FormControlLabel_1.default, { className: go, classes: {
            root: labelRoot,
            disabled: labelDisabled,
            label: labelText,
        }, control: checkboxEl, label: label, labelPlacement: labelPlacement }));
}));
